import { render, staticRenderFns } from "./EvaluationsComponent.vue?vue&type=template&id=8c1e349e&scoped=true"
import script from "./EvaluationsComponent.vue?vue&type=script&lang=js"
export * from "./EvaluationsComponent.vue?vue&type=script&lang=js"
import style0 from "./EvaluationsComponent.vue?vue&type=style&index=0&id=8c1e349e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c1e349e",
  null
  
)

export default component.exports